import React, { useEffect } from 'react';
import { Navigate, RouteProps } from 'react-router-dom';
import { useAuth } from '../provider/AuthProvider';

const PrivateRoute: React.FC<RouteProps> = ({ element }) => {
  const { isAuthenticated } = useAuth();
  useEffect(() => {
    console.log('isAuthenticated', isAuthenticated);
  }, [isAuthenticated]);
  return isAuthenticated ? <>{element}</> : <Navigate to="/login" />;
};

export default PrivateRoute;